import { render } from "./Onderhoud.vue?vue&type=template&id=590326ff&scoped=true&ts=true"
import script from "./Onderhoud.vue?vue&type=script&lang=ts"
export * from "./Onderhoud.vue?vue&type=script&lang=ts"

import "./Onderhoud.vue?vue&type=style&index=0&id=590326ff&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590326ff"]])

export default __exports__